<template>
  <Header></Header>
  <div><el-image :src="cd_dt"></el-image></div>
  <div>
    <div class="title">椰棕床褥</div>
    <div class="subtitle">可定制規格尺寸</div>
    <div class="yzmk clearfix">
      <div class="yz" v-for="item of yz" :key="item.index"   @click="openBox(item.prod_sn)">
        <el-image class="yz-tp" :src="item.url"></el-image>
        <div class="yz-wz">{{ item.prod_des }}</div>
      </div>
    </div>
  </div>
  <div>
    <div class="title">超力膠床褥</div>
    <div class="subtitle">可定制規格尺寸</div>
    <div class="cljmk clearfix">
      <div class="clj" v-for="item of clj" :key="item.index"   @click="openBox(item.prod_sn)">
        <el-image class="clj-tp" :src="item.url"></el-image>
        <div class="clj-wz">{{ item.prod_des }}</div>
      </div>
    </div>
  </div>
  <div>
    <div class="title">彈簧床褥</div>
    <div class="subtitle">可定制規格尺寸</div>
    <div class="cljmk clearfix">
      <div class="clj" v-for="item of th" :key="item.index"   @click="openBox(item.prod_sn)">
        <el-image class="clj-tp" :src="item.url"></el-image>
        <div class="clj-wz">{{ item.prod_des }}</div>
      </div>
    </div>
  </div>
  <Footer></Footer>
      <Box
      :dialogVisible="box.dialogVisible"
      :goods_id="box.goods_id"
      @close="boxClose"
    ></Box>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Box from "@/components/Box";
export default {
  name: "Contact",
  data() {
    return {
      company_sn:"R",
      cd_dt: "http://139.159.153.112:8200/gw_lmm/cd1.jpg",
      yz:[],
      clj:[],
      th:[],
       box: {
        dialogVisible: false,
        goods_id: "",
      },
      // yz: [
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/yz/1.jpg",
      //     des: "椰棕保健床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/yz/2.jpg",
      //     des: "心心高級混凝保健床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/yz/3.jpg",
      //     des: "美健高级椰棕床褥",
      //   },
      // ],
      // clj: [
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/clj/1.jpg",
      //     des: "蘆薈波浪膠舒適床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/clj/2.jpg",
      //     des: "蘆薈寶健康膠床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/clj/3.jpg",
      //     des: "水晶膠床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/clj/4.jpg",
      //     des: "藍網膠床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/clj/5.jpg",
      //     des: "灰網膠床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/clj/6.jpg",
      //     des: "紅網膠床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/clj/7.jpg",
      //     des: "杏網膠床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/clj/8.jpg",
      //     des: "金鑽雙面健康床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/clj/9.jpg",
      //     des: "美的夢豪華膠床褥",
      //   },
      // ],
      // th: [
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/th/1.jpg",
      //     des: "美的夢ISO9001護脊型床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/th/2.jpg",
      //     des: "銀至尊",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/th/3.jpg",
      //     des: "兒護型袋裝床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/th/4.jpg",
      //     des: "幸運星輕型舒適彈弓床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/th/5.jpg",
      //     des: "金至尊中量级床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/th/6.jpg",
      //     des: "乳膠彈簧床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/th/7.jpg",
      //     des: "獨立袋裝彈簧床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/th/8.jpg",
      //     des: "超级型三面床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/th/9.jpg",
      //     des: "舒壓型彈簧床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/th/10.jpg",
      //     des: "美的夢特硬型床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/th/11.jpg",
      //     des: "美的夢之寶",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/th/12.jpg",
      //     des: "金至尊(新版)",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/th/13.jpg",
      //     des: "蘆薈舒適健康床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/th/14.jpg",
      //     des: "蘆薈三面護脊床褥",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cd/th/15.jpg",
      //     des: "蘆薈智能恒溫床褥",
      //   },
      // ],
    };
  },
  components: { Header, Footer,Box },
  created(){
    if(sessionStorage.getItem("company_sn")!=null){
      this.company_sn=sessionStorage.getItem("company_sn")
      this.queryProdYZ()
      this.queryProdCLJ()
      this.queryProdTH()
    }
  },
  methods:{
    openBox(goods_id) {
      this.box.dialogVisible = true;
      this.box.goods_id = goods_id;
    },
    // 弹窗的搜索关闭
    boxClose(val) {
      this.box.dialogVisible = val;
    },
    // 查询推荐货品
    queryProdYZ() {
      this.$api.queryprod({company_sn:this.company_sn,category_sn:"A001",high:0}).then(
        res => {
          if (res.state == 10000) {
            this.yz=res.data.prod
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
    // 查询推荐货品
    queryProdCLJ() {
      this.$api.queryprod({company_sn:this.company_sn,category_sn:"A002",high:0}).then(
        res => {
          if (res.state == 10000) {
            this.clj=res.data.prod
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
        // 查询推荐货品
    queryProdTH() {
      this.$api.queryprod({company_sn:this.company_sn,category_sn:"A003",high:0}).then(
        res => {
          if (res.state == 10000) {
            this.th=res.data.prod
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
  }
};
</script>

<style scoped>
.title {
  margin-top: 60px;
  font-size: 40px;
  color: rgb(51, 51, 51);
}
.subtitle {
  font-size: 16px;
  line-height: 72px;
  color: rgb(51, 51, 51);
}
/* 沙發床 */
.yzmk {
  width: 1260px;
  margin: 0 auto;
}
.yz {
  float: left;
  width: 380px;
  height: 380px;
  margin: 20px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
}
.yz-tp {
  width: 380px;
  height: 300px;
}

/* 椅子 */
.cljmk {
  width: 1260px;
  margin: 0 auto;
}
.clj {
  float: left;
  width: 275px;
  height: 275px;
  margin: 20px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
}
</style>